import { Button, Paper } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { t } from '@ankr.com/common';

import { AmountBadge } from 'modules/notifications/components/AmountBadge';

import { SoonLabel } from '../../../SoonLabel';
import { getCommonButtonProps } from './utils/getCommonButtonProps';
import { getExternalButtonProps } from './utils/getExternalButtonProps';
import { getNotLinkButtonProps } from './utils/getNotLinkButtonProps';
import { useBaseNavButtonStyles } from './useBaseNavButtonStyles';
import { AccordionNavButton } from '../AccordionNavButton';
import { IUseBaseNavButtonParams, useBaseNavButton } from './useBaseNavButton';

export interface IBaseNavButtonProps extends IUseBaseNavButtonParams {}

export const BaseNavButton = ({
  handleSidebarClose,
  isMobileSideBar = false,
  item,
}: IBaseNavButtonProps) => {
  const {
    StartIcon,
    amount,
    handleCloseOnClick,
    hasAccess,
    isAccordionButton,
    isComingSoon,
    isDisabled,
    isExternalHref,
    isLightTheme,
    isNew,
    isNotLinkItem,
    label,
    onClick,
  } = useBaseNavButton({
    handleSidebarClose,
    isMobileSideBar,
    item,
  });

  const { classes, cx } = useBaseNavButtonStyles({
    isLightTheme,
    isMobileSideBar,
  });

  if (isExternalHref) {
    return (
      <Button
        {...getExternalButtonProps(item)}
        className={cx(
          classes.navBarLink,
          isComingSoon && classes.comingSoon,
          isDisabled && classes.disabled,
          isNew && classes.newLinkWrapper,
        )}
        startIcon={<StartIcon />}
      >
        {label}
        {isNew && (
          <Paper className={classes.newLabelWrapper}>
            <SoonLabel className={classes.soon} label={t('common.new')} />
          </Paper>
        )}
        {isComingSoon && <SoonLabel className={classes.soon} />}
      </Button>
    );
  }

  if (isNotLinkItem) {
    return (
      <Button
        {...getNotLinkButtonProps(item, hasAccess)}
        className={cx(
          classes.navBarLink,
          isComingSoon && classes.comingSoon,
          isDisabled && classes.disabled,
        )}
        startIcon={<StartIcon />}
      >
        {label}
        {isComingSoon && <SoonLabel className={classes.soon} />}
      </Button>
    );
  }

  if (isAccordionButton) {
    return (
      <AccordionNavButton
        buttonItem={item}
        isMobileSideBar={isMobileSideBar}
        onClick={handleCloseOnClick}
      />
    );
  }

  return (
    <Button
      {...getCommonButtonProps(item, classes.activeLink)}
      className={cx(
        classes.navBarLink,
        isComingSoon && classes.comingSoon,
        isDisabled && classes.disabled,
        isNew && classes.newLinkWrapper,
      )}
      component={NavLink}
      startIcon={<StartIcon />}
      onClick={onClick}
    >
      {label}
      {amount !== undefined && amount > 0 && (
        <AmountBadge isBig amount={amount} className={classes.amount} />
      )}
      {isNew && (
        <Paper className={classes.newLabelWrapper}>
          <SoonLabel className={classes.soon} label={t('common.new')} />
        </Paper>
      )}
      {isComingSoon && <SoonLabel className={classes.soon} />}
    </Button>
  );
};
